var TeaserLayout;
(function (TeaserLayout) {
    TeaserLayout["VARIANT_A"] = "teaser-variant-a";
    TeaserLayout["VARIANT_B"] = "teaser-variant-b";
    TeaserLayout["VARIANT_C"] = "teaser-variant-c";
    TeaserLayout["VARIANT_D"] = "teaser-variant-d";
    TeaserLayout["VARIANT_E"] = "teaser-variant-e";
    TeaserLayout["VARIANT_E_WITHOUT_DESCRIPTION"] = "teaser-variant-e-without-description";
    TeaserLayout["VARIANT_A_WITHOUT_IMAGE"] = "teaser-variant-a-without-image";
    TeaserLayout["VARIANT_B_WITHOUT_IMAGE"] = "teaser-variant-b-without-image";
    TeaserLayout["VARIANT_C_WITHOUT_IMAGE"] = "teaser-variant-c-without-image";
    TeaserLayout["VARIANT_D_WITHOUT_IMAGE"] = "teaser-variant-d-without-image";
    TeaserLayout["VARIANT_C_WITHOUT_IMAGE_WITH_DATE"] = "teaser-variant-c-without-image-with-date";
    TeaserLayout["CARD_A"] = "teaser--card-a";
    TeaserLayout["CARD_B"] = "teaser--card-b";
    TeaserLayout["CARD_C"] = "teaser--card-c";
    TeaserLayout["RESULT"] = "teaser--result";
    TeaserLayout["PUBMED"] = "teaser--pubmed";
})(TeaserLayout || (TeaserLayout = {}));
Object.values(TeaserLayout);
var Target;
(function (Target) {
    Target["SELF"] = "_self";
    Target["BLANK"] = "_blank";
})(Target || (Target = {}));

export { TeaserLayout as T, Target as a };

//# sourceMappingURL=roche-teaser.types.js.map